<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/zonas`;
const token = utilsService.getToken();

const zonaService = {
  async getZonasOptions() {
    try {
      const response = await axios.get(`${apiUrl}/options/zonas`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
  async getPaisesOptions() {
    try {
      const response = await axios.get(`${apiUrl}/options/paises`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
  async getRegionesOptions(pais) {
    try {
      const response = await axios.get(`${apiUrl}/${pais}/options/regiones`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
  async getComunasOptions(region) {
    try {
      const response = await axios.get(`${apiUrl}/${region}/options/comunas`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
};

export default zonaService;
</script>
